/**
 * Stage event handlers
 */
import { deleteStage, addStage } from './ajax.js';
import { ListView } from '../list/index.js';

const MIN_STAGES = 7;
const MAX_STAGES = 15;

function getStageCount() {
	const container = document.getElementById('stages-container');
	return container ? container.querySelectorAll('.stage-item').length : 0;
}

function updateStageButtons() {
	const count = getStageCount();
	const removeButtons = document.querySelectorAll('[data-action="remove-stage"]');
	const addButton = document.querySelector('[data-action="add-stage"]');
	const addPopupButton = document.querySelector('[onclick*="add-stage"]');

	removeButtons.forEach(btn => {
		btn.disabled = count <= MIN_STAGES;
		if (count <= MIN_STAGES) {
			btn.title = wpcore.direct_t({ en: `Minimum ${MIN_STAGES} stages required`, fr: `Minimum ${MIN_STAGES} étapes requises` });
		} else {
			btn.title = '';
		}
	});

	if (addButton) {
		addButton.disabled = count >= MAX_STAGES;
	}
	if (addPopupButton) {
		if (count >= MAX_STAGES) {
			addPopupButton.disabled = true;
			addPopupButton.classList.add('cursor-not-allowed', 'opacity-50');
			addPopupButton.title = wpcore.direct_t({ en: `Maximum ${MAX_STAGES} stages allowed`, fr: `Maximum ${MAX_STAGES} étapes autorisées` });
		} else {
			addPopupButton.disabled = false;
			addPopupButton.classList.remove('cursor-not-allowed', 'opacity-50');
			addPopupButton.title = '';
		}
	}
}

/**
 * Initialize stage handlers
 */
export function initStageHandlers() {
	initDeleteHandler();
	initAddStageHandler();
	initStageListView();
	updateStageButtons();
}

/**
 * Handle stage deletion
 */
function initDeleteHandler() {
	document.addEventListener('click', async (e) => {
		const removeBtn = e.target.closest('[data-action="remove-stage"]');
		if (!removeBtn) return;

		if (getStageCount() <= MIN_STAGES) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), wpcore.direct_t({ en: `Minimum ${MIN_STAGES} stages required`, fr: `Minimum ${MIN_STAGES} étapes requises` }));
			return;
		}

		const stageItem = removeBtn.closest('.stage-item');
		if (!stageItem) return;

		const stageId = stageItem.dataset.stageId;
		if (!stageId) return;

		try {
			removeBtn.disabled = true;
			await deleteStage(stageId);

			// Remove stage item from DOM
			stageItem.remove();

			// Update stage numbers and button states
			updateStageNumbers();
			updateStageButtons();

			// Show success message
			wpcore.alert('success', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), wpcore.direct_t({ en: 'Stage deleted successfully', fr: 'Étape supprimée avec succès' }));
		} catch (error) {
			removeBtn.disabled = false;
			wpcore.alert('error', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), error.message || wpcore.direct_t({ en: 'Failed to delete stage', fr: 'Échec de la suppression de l\'étape' }));
		}
	});
}

/**
 * Handle add stage form submission
 */
function initAddStageHandler() {
	document.addEventListener('click', async (e) => {
		const addBtn = e.target.closest('[data-action="add-stage"]');
		if (!addBtn) return;

		e.preventDefault();

		if (getStageCount() >= MAX_STAGES) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), wpcore.direct_t({ en: `Maximum ${MAX_STAGES} stages allowed`, fr: `Maximum ${MAX_STAGES} étapes autorisées` }));
			return;
		}

		const form = document.getElementById('add-stage-form');
		if (!form) return;

		try {
			addBtn.disabled = true;
			addBtn.textContent = wpcore.direct_t({ en: 'Creating...', fr: 'Création...' });

			const formData = new FormData(form);
			await addStage(formData);

			// Close popup and reload page with tab param
			wpcore.closePopup('add-stage');
			const url = new URL(window.location.href);
			url.searchParams.set('tab', 'edit-stages');
			window.location.href = url.toString();
		} catch (error) {
			wpcore.alert('error', wpcore.direct_t({ en: 'Stage', fr: 'Étape' }), error.message || wpcore.direct_t({ en: 'Failed to add stage', fr: 'Échec de l\'ajout de l\'étape' }));
			addBtn.disabled = false;
			addBtn.textContent = wpcore.direct_t({ en: 'Create', fr: 'Créer' });
		}
	});
}

/**
 * Initialize stage ListView with drag and drop
 */
function initStageListView() {
	new ListView({
		containerId: 'stages-container',
		itemClass: 'stage-item',
		dragOverClass: 'drag-over',
		updateItemNumbers: updateStageNumbers
	});
}

/**
 * Update stage numbers after reorder
 */
function updateStageNumbers() {
	const container = document.getElementById('stages-container');
	if (!container) return;

	const stageItems = container.querySelectorAll('.stage-item');
	stageItems.forEach((item, index) => {
		const numberEl = item.querySelector('.stage-item-number');
		const titleEl = item.querySelector('.stage-item-title');

		if (numberEl) {
			numberEl.textContent = index + 1;
		}
		if (titleEl) {
			titleEl.textContent = wpcore.direct_t({ en: 'Stage', fr: 'Étape' }) + ` ${index + 1}`;
		}
	});
}

